import {
  GET_APPLICATIONS,
  GET_APPLICATIONS_SUCCESS,
  GET_APPLICATIONS_FAILURE,
  CHANGE_APP_STATUS,
  CHANGE_APP_STATUS_SUCCESS,
  CHANGE_APP_STATUS_FAILURE,
  GET_APPLICATION_DETAILS,
  GET_APPLICATION_DETAILS_SUCCESS,
  GET_APPLICATION_DETAILS_FAILURE,
  REQ_LOR,
  REQ_LOR_SUCCESS,
  REQ_LOR_FAILURE,
} from "../constants";

export default class ApplicationAction {
  static getApplications(payload, cb) {
    return {
      type: GET_APPLICATIONS,
      payload,
      cb,
    };
  }
  static getApplicationsSuccess(payload) {
    return {
      type: GET_APPLICATIONS_SUCCESS,
      payload,
    };
  }
  static getApplicationsFailure(payload) {
    return {
      type: GET_APPLICATIONS_FAILURE,
      payload,
    };
  }
  static changeApplicationStatus(payload, cb) {
    return {
      type: CHANGE_APP_STATUS,
      payload,
      cb,
    };
  }
  static changeApplicationStatusSuccess(payload) {
    return {
      type: CHANGE_APP_STATUS_SUCCESS,
      payload,
    };
  }
  static changeApplicationStatusFailure(payload) {
    return {
      type: CHANGE_APP_STATUS_FAILURE,
      payload,
    };
  }
  static getApplicationDetails(payload, cb) {
    return {
      type: GET_APPLICATION_DETAILS,
      payload,
      cb,
    };
  }
  static getApplicationDetailsSuccess(payload) {
    return {
      type: GET_APPLICATION_DETAILS_SUCCESS,
      payload,
    };
  }
  static getApplicationDetailsFailure(payload) {
    return {
      type: GET_APPLICATION_DETAILS_FAILURE,
      payload,
    };
  }
  static reqLOR(payload, cb) {
    return {
      type: REQ_LOR,
      payload,
      cb,
    };
  }
  static reqLORSuccess(payload) {
    return {
      type: REQ_LOR_SUCCESS,
      payload,
    };
  }
  static reqLORFailure(payload) {
    return {
      type: REQ_LOR_FAILURE,
      payload,
    };
  }
}
